import { motion } from "framer-motion";
import { Star, Truck } from "lucide-react";
import { fadeDown, fadeLeft, fadeUp, staggerContainer } from "@/lib/animations";

const trustItems = [
  { icon: <Star className="h-5 w-5" />, label: "10,000+ Happy Customers" },
  { icon: <Truck className="h-5 w-5" />, label: "Free Insured Delivery" },
];

export function HeroSection() {
  return (
    <section
      id="home"
      className="pb-10 md:pb-16 lg:pb-20 pt-6 md:pt-0 overflow-hidden"
    >
      <div className="wrapper">
        <div className="relative rounded-3xl bg-primary overflow-hidden">
          {/* Decorative circles */}
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-white/5 pointer-events-none" />
          <div className="absolute -bottom-16 -left-16 w-64 h-64 rounded-full bg-white/5 pointer-events-none" />

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-0 min-h-[420px] md:min-h-[500px]">
            {/* Left: Text */}
            <motion.div
              className="flex flex-col justify-center xl:px-16 lg:px-12 px-6 py-10 md:py-14"
              variants={staggerContainer}
              initial="hidden"
              animate="visible"
            >
              {/* Badge */}
              <motion.div
                variants={fadeDown}
                className="inline-flex items-center gap-2 w-fit px-4 py-2 rounded-full bg-white/15 mb-5"
              >
                <span className="text-white text-lg">✦</span>
                <span className="text-white text-sm font-semibold tracking-wide">
                  German Silver Jewellery
                </span>
              </motion.div>

              {/* Headline */}
              <motion.h1
                variants={fadeUp}
                className="text-white font-bold leading-tight mb-4"
                style={{ fontSize: "clamp(28px, 5vw, 56px)" }}
              >
                Crafted in German Silver.
                <br />
                <span className="text-white/80">Worn Forever.</span>
              </motion.h1>

              <motion.p
                variants={fadeUp}
                className="text-white/75 text-base md:text-lg leading-relaxed mb-8 max-w-md"
              >
                Discover our exclusive collection of handcrafted silver rings —
                priced at live market rates with zero compromise on quality.
              </motion.p>

              {/* Trust Row */}
              <motion.div
                variants={staggerContainer}
                className="flex flex-wrap gap-5 pt-6 border-t border-white/15"
              >
                {trustItems.map((item, i) => (
                  <motion.div
                    key={i}
                    variants={fadeUp}
                    className="flex items-center gap-2"
                  >
                    <div className="w-9 h-9 rounded-xl bg-white/15 flex items-center justify-center text-white shrink-0">
                      {item.icon}
                    </div>
                    <span className="text-white/90 text-sm font-medium">
                      {item.label}
                    </span>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>

            {/* Right: Silver ring image */}
            <motion.div
              className="hidden lg:flex items-end justify-center overflow-hidden relative"
              variants={fadeLeft}
              initial="hidden"
              animate="visible"
            >
              <div className="absolute inset-0 bg-gradient-to-l from-transparent via-white/5 to-primary/80 pointer-events-none z-10" />
              <img
                src="https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=700&h=600&fit=crop"
                alt="Silver Ring"
                className="w-full h-full object-cover object-center opacity-80"
              />
              {/* Price tag overlay */}
              <div className="absolute bottom-8 right-8 z-20 bg-white/95 rounded-2xl px-5 py-3 shadow-xl">
                <p className="text-xs text-muted-foreground">Starting from</p>
                <p className="text-2xl font-bold text-primary">₹499</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
